export const TARGETS = {
  SUMMARY: 'Summary',
  ACTION_ITEMS: 'Action Items',
  DISCUSSION: 'Discussion',
}

export const THUMB_FEEDBACK = {
  NONE: 0,
  UP: 1,
  DOWN: -1
}

export const FEEDBACK_OPTIONS_STATUS = {
  OPEN: 'OPEN',
  CLOSED: 'CLOSED',
  THANK_YOU: 'THANK YOU'
}

export const FEEDBACK_OPTIONS = {
  OTHER: 'Other'
}

export const TEMPLATE_STATUS = {
  REQUESTED: 'REQUESTED',
  COMPLETED: 'COMPLETED'
}

export const TEMPLATE_TYPE = {
  AUTO: 'AUTO',
  GENERIC: 'GENERIC',
  MEDDIC: 'MEDDIC',
  BANT: 'BANT',
  QNA: 'QNA'
}

export const RECAP_FEATURE = {
  PASSAGE_SEARCH: 'passage_search',
  KEYWORD_SEARCH: 'keyword_search',
}
